// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电路（二）",
      "tec": "姚宗君郭瑞",
      "week": "1-10,13-14周",
      "add": "教学楼D座121新能"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "杨宇",
      "week": "1-10,13-18双周",
      "add": "教学楼D座418教务处"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "李丹",
      "week": "1-9,13-15周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "工程化学",
      "tec": "李英杰",
      "week": "1-10,13周",
      "add": "教学楼D座124新能"
    },
    {
      "sub": "工程力学",
      "tec": "周金华",
      "week": "1-10,13-14周",
      "add": "教学楼D座124新能"
    }
  ],
  "2": [
    [
      {
        "sub": "大学英语（三）",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25新能源1-3",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "25新能源1-1",
        "tec": "文菲",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25新能源2-1",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "教学楼A座125信息"
      }
    ],
    {
      "sub": "大学物理（下)",
      "tec": "齐志华",
      "week": "1-10,13-16周",
      "add": "教学楼C座308教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "李明飞",
      "week": "1-4周",
      "add": "教学楼C座212教务"
    },
    [
      {
        "sub": "形势与政策",
        "tec": "单超",
        "week": "1-4周",
        "add": "教学楼C座213教务"
      },
      {
        "sub": "就业创业指导",
        "tec": "赵明明王梓",
        "week": "5-9周",
        "add": "教学楼C座306教务"
      }
    ],
    0
  ],
  "3": [
    {
      "sub": "概率论与数理统计",
      "tec": "杨宇",
      "week": "1-10,13-18周",
      "add": "教学楼C座308教务"
    },
    {
      "sub": "电路（二）",
      "tec": "姚宗君郭瑞",
      "week": "1-10,13-14周",
      "add": "教学楼C座305教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "马克思主义基本原理",
      "tec": "李丹",
      "week": "1-9,13-15周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "李宏波",
      "week": "1-10,13-18周",
      "add": "教学楼C座210教务"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "女乒",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "足球",
        "tec": "李罡",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "足球",
        "tec": "李莉",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "女羽",
        "tec": "李灏",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "男乒",
        "tec": "郝策",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "男网",
        "tec": "李庆",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "轮滑",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "搏击",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "男篮",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "男篮",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "女排",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "健美操",
        "tec": "张慧",
        "week": "1-18周",
        "add": "女网"
      },
      {
        "sub": "女篮",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "女网"
      }
    ],
    0,
    {
      "sub": "工程力学",
      "tec": "周金华",
      "week": "1-10,13-14周",
      "add": "教学楼A座317机械"
    }
  ],
  "5": [
    {
      "sub": "大学物理（下)",
      "tec": "齐志华",
      "week": "1-10,13-16周",
      "add": "教学楼C座308教务"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "文菲",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25新能源2-1",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25新能源1-3",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "25新能源1-2",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "教学楼A座119信息"
      }
    ],
    {
      "sub": "创造性思维与创新方法",
      "tec": "高庆忠",
      "week": "1-10,13-18周",
      "add": "教学楼D座121新能"
    },
    {
      "sub": "工程化学",
      "tec": "李英杰",
      "week": "2,4,6,8,10周",
      "add": "教学楼D座124新能"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
